const interopOptions = (options, imports) => {
  void imports // Left unused intentionally
  return options
}

export default interopOptions
